import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="py-20 sm:py-24 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Industries</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
            Industries we serve
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Domain-specialized recruiters and account teams for every major Indian sector.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 sm:gap-4">
          {INDUSTRIES.map(({ icon: Icon, name }, i) => (
            <div
              key={name}
              data-testid={`industry-${i}`}
              className="group bg-white border border-slate-200 rounded-2xl p-5 sm:p-6 text-center hover:border-primary/40 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 ease-out"
            >
              <div className="w-11 h-11 mx-auto rounded-xl bg-primary/10 group-hover:bg-primary flex items-center justify-center mb-3 transition-colors">
                <Icon className="w-5 h-5 text-primary group-hover:text-white" strokeWidth={1.6} />
              </div>
              <p className="text-xs sm:text-sm font-semibold text-slate-800 leading-tight">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
